module.exports = __webpack_public_path__ + "static/img/rotate03.984f81a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/horse/rotate03.png
// module id = WJRJ
// module chunks = 1